import { logger } from "@domain/infrastructure/logger";

// Apollo 4 rejects a useLazyQuery execute with AbortError when a newer execute of the same hook supersedes it.
export const isAbortError = (error: unknown): boolean =>
    (error instanceof DOMException || error instanceof Error) && error.name === "AbortError";

// For fire-and-forget requests where only the newest result matters.
export const ignoreAbort = (error: unknown): void => {
    if (isAbortError(error)) {
        return;
    }
    logger.crit(error instanceof Error ? error : new Error(String(error)));
};
